<div class="main-content">
  <div class="header-actions">
    <h4 class="card-title">Pending Orders</h4>
    <fh-refresh-button [refresh]="refreshData" />
  </div>

  <fh-filter-bar (resetFilters)="onResetFilters()">
    <fh-form-autocomplete
      [options]="countryOptions()"
      [label]="'Country'"
      [placeholder]="'Select country...'"
      [showCounts]="false"
      appearance="outline"
      [formControl]="countryFilterFormControl"
      (selectionChange)="onCountryChange($any($event))"
    />

    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search Orders</mat-label>
      <input
        matInput
        [value]="searchTerm()"
        (input)="searchTerm.set($any($event.target).value)"
        (keyup.enter)="onSearchChange(searchTerm())"
        placeholder="Search..."
      />
      <button matSuffix mat-icon-button (click)="onSearchChange(searchTerm())">
        <mat-icon>search</mat-icon>
      </button>
      @if (searchTerm()) {
        <button
          matSuffix
          mat-icon-button
          (click)="searchTerm.set(''); onSearchChange('')"
          class="clear-button"
        >
          <mat-icon>clear</mat-icon>
        </button>
      }
    </mat-form-field>
  </fh-filter-bar>

  <fh-data-table
    [config]="tableConfig()"
    [sortProp]="sortProp()"
    [sortDir]="sortDir()"
    [pageIndex]="pageIndex()"
    [pageSize]="pageSize()"
    [actions]="tableActions()"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
  />
</div>
